import { TEXT } from "../../shared/constants/texts";
import { UPLOAD_FLOW, UPLOAD_REQUEST_FROM } from "../../shared/constants/uploadParams";
import ConfigService from "../../shared/services/configService";
import { logError } from "../../shared/services/errorLogging";
import { msGraphTokenFromRefreshTokenApiCall, redirectToLogin, uploadApiCall } from "./redux/apiCalls";
import {
  showNotificationSuccess,
  hideNotification,
  showNotificationWarning,
  showNotificationError,
  stopUploadingDndAssociation,
  stopUploadingDndFolder,
  stopUploadingDndAssociationInstance,
  stopUploadingDndFolderInstance,
  stopUploadingDndAgreement,
  storeUploadSingleEmailThreadData,
  stopUploadingSingleEmailThread,
  showReplaceExistingPopup,
  storeReplaceExistingData,
  hideSingleEmailUpload,
  showIsUploadDoneSingleEmail,
} from "./redux/slice";
import { getUploadRequestData } from "./utilFunctions";

const configService = new ConfigService();

export const transformAgreementData = (newResponseData, prevData) => {
  const previousDataRows = [...prevData.rows];
  const data = newResponseData.data;
  let dataRows = [];
  if (data && data.rows && data.rows.length > 0) {
    dataRows = [...data.rows];
  }
  const newRows = previousDataRows.concat(dataRows);
  const newData = {
    rows: newRows,
    rowTotal: newRows.length,
    total: data.total,
  };
  return newData;
};

export const callToUploadApi = async (data) => {
  const { state, flow, dnd, type, from, dispatch, history, errorValidationMsg, onUpload } = data;
  const { selectedAgreement, ewsUrlData, singleEmailData } = state;
  const hasAttachments = singleEmailData && singleEmailData.attachments && singleEmailData.attachments.length > 0;
  const mailbox = Office.context.mailbox;
  let requestBody = {};
  if (mailbox && mailbox.item) {
    const token = "";
    const isMsGraphEnabled = configService.getMsGraphFlag().toString();
    let msGraphUrl = configService.getMsGraphUrl().toString();
    if (!msGraphUrl || msGraphUrl == "undefined") {
      msGraphUrl = "https://graph.microsoft.com";
    }
    if (isMsGraphEnabled === "true") {
      const msGraphRedirectUrl = configService.getRedirectUri().toString();
      const accessTokenFromRefreshToken = await msGraphTokenFromRefreshTokenApiCall({
        dispatch: dispatch,
        history: history,
        requestData: {
          refreshToken: localStorage.getItem(TEXT.MSG_REFRESH_TOKEN),
          redirectUrl: encodeURIComponent(msGraphRedirectUrl),
        },
      });
      const { response, error } = accessTokenFromRefreshToken;
      if (response) {
        const accessToken = response.AccessToken || "";
        const refreshToken = response.RefreshToken || "";
        localStorage.setItem(TEXT.MSG_ACCESS_TOKEN, accessToken);
        localStorage.setItem(TEXT.MSG_REFRESH_TOKEN, refreshToken);
      }
      if (error) {
        logError({
          dispatch: dispatch,
          err: error,
          callerInfo: {
            callerFunction: "ClientApp|src|taskpane|containers|add-to-ici|utils - callToUploadApi",
            callerApi: "api/user/GetUserMsGraphToken?code=&state=&session_state=&redirectUrl=",
          },
        });
        localStorage.setItem(TEXT.MSG_ACCESS_TOKEN, "");
        localStorage.setItem(TEXT.MSG_REFRESH_TOKEN, "");
        redirectToLogin(history);
      }
    }
    let agreement = selectedAgreement;
    if (!agreement) {
      agreement = JSON.parse(localStorage.getItem("selectedAgreement"));
    }
    const uploadDataForApi = await getUploadRequestData(data);
    requestBody = {
      DragAndDrop: dnd,
      DragDropType: type,
      hasAttachments: hasAttachments,
      attachments: uploadDataForApi,
      attachmentToken: token,
      msGraphAccessToken: localStorage.getItem(TEXT.MSG_ACCESS_TOKEN) || "",
      msGraphRefreshToken: localStorage.getItem(TEXT.MSG_REFRESH_TOKEN) || "",
      setCategoryToMessageUrl: `${msGraphUrl}/v1.0/users/${localStorage.getItem(TEXT.USER_EMAIL_ID)}/messages/`,
      setCategoryToMessageProperties: configService.getCategory().toString(),
      ewsUrl: ewsUrlData,
      state: 3,
      agreementId: agreement.sysId,
      fileType: 1,
      loggedInUserId: dnd ? "1" : "3",
      answer: false,
      contractTypeName: agreement.entityName,
      messageUrl: `${msGraphUrl}/v1.0/me/messages?$filter=internetMessageId eq '%3CMessageIdFromInternet%3E'`,
    };
  }
  const uploadResponse = await uploadApiCall({
    dispatch: dispatch,
    history: history,
    errorValidationMsg: errorValidationMsg,
    requestData: requestBody,
    retryFunctionCall: () => callToUploadApi(data),
  });
  const { response, error } = uploadResponse;
  if (flow === UPLOAD_FLOW.DRAG_AND_DROP) {
    if (response) {
      uploadResponseHandlerDnD({
        response: response,
        data: data,
        from: from,
        dispatch: dispatch,
        errorValidationMsg: errorValidationMsg,
        onUpload: onUpload,
      });
    }
    if (error) {
      stopUploadingDnD({
        from: from,
        dispatch: dispatch,
        onUpload: () => {},
        alreadyUploadedItems: [],
      });
    }
  }
  if (flow === UPLOAD_FLOW.SINGLE_EMAIL_UPLOAD) {
    if (response) {
      uploadResponseHandlerSingleEmailUpload({
        data: response,
        dispatch: dispatch,
        retryFunction: () => callToUploadApi(data),
        errorValidationMsg: errorValidationMsg,
      });
    }
    if (error) {
      stopUploadingSingleEmailUpload({ dispatch: dispatch });
    }
  }
  if (flow === UPLOAD_FLOW.DRAG_AND_DROP_SINGLE_EMAIL_THREAD) {
    if (response) {
      uploadResponseHandlerDnDSingleEmailThreadUpload({ response: response, dispatch: dispatch });
    }
    if (error) {
      stopUploadingDnDSingleEmailThreadUpload({ dispatch: dispatch });
      dispatch(storeUploadSingleEmailThreadData(null));
    }
  }
  if (flow === UPLOAD_FLOW.SINGLE_EMAIL_THREAD_UPLOAD_REPLACE_POPUP) {
    if (response) {
      uploadResponseHandlerSingleEmailThreadReplacePopup({
        dispatch: dispatch,
        data: response,
        onUpload: onUpload,
      });
    }
    if (error) {
      stopUploadingSingleEmailThreadReplacePopup({ onUpload: onUpload });
    }
  }
  if (error) {
    logError({
      dispatch: dispatch,
      err: error,
      callerInfo: {
        callerFunction: "ClientApp|src|taskpane|containers|add-to-ici|utils - callToUploadApi",
        callerApi: "Agreement/UploadDocumentsForAddIn",
      },
    });
  }
};

const uploadResponseHandlerDnD = ({ response, data, from, dispatch, errorValidationMsg, onUpload }) => {
  const responseItems =
    response && response.responseItems && response.responseItems.length > 0 ? response.responseItems : [];
  let responseItemsCount = 0,
    successCount = 0,
    failedItems = [],
    failedCount = 0,
    alreadyUploadedItems = [],
    alreadyUploadedCount = 0,
    notificationMsg = "";
  if (responseItems && responseItems.length > 0) {
    responseItemsCount = responseItems.length;
    successCount = responseItems.filter((responseItem) => responseItem.Status === TEXT.SUCCESS).length;
    failedItems = responseItems.filter(
      (responseItem) => responseItem.Status === TEXT.FAILURE || responseItem.Status === TEXT.FAILED
    );
    failedCount = failedItems.length;
    alreadyUploadedItems = responseItems.filter((responseItem) => responseItem.Status === TEXT.ALREADY_UPLOADED);
    alreadyUploadedCount = alreadyUploadedItems.length;
    if (responseItemsCount === successCount) {
      notificationMsg = `${successCount} ${TEXT.EMAILS_UPLOADED_TO_ICI_SUCCESSFULLY}`;
      dispatch(showNotificationSuccess(notificationMsg));
      setTimeout(() => {
        dispatch(hideNotification());
      }, 5000);
    } else if (responseItemsCount === alreadyUploadedCount) {
      notificationMsg = `${alreadyUploadedCount} ${TEXT.EMAILS_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY}`;
      dispatch(showNotificationWarning(notificationMsg));
      setTimeout(() => {
        dispatch(hideNotification());
      }, 5000);
    } else if (responseItemsCount > 1 && failedCount > 1 && responseItemsCount === failedCount) {
      notificationMsg = `${failedCount} ${TEXT.EMAILS_FAILED_TO_BE_UPLOADED_TO_ICI}\n`;
      notificationMsg = notificationMsg.replace(/(^\n)|(\n$)/g, "") + `\n`;
      failedItems.forEach((item) => {
        if (isActionValidatorPresent(item) && actionValidatorMessage(item, errorValidationMsg)) {
          notificationMsg += `\n${actionValidatorMessage(item, errorValidationMsg)}\n`;
        } else {
          notificationMsg += `\n${item.ResponseMsg}\n`;
        }
      });
      dispatch(
        showNotificationError({
          message: notificationMsg,
          retryFunction: () => callToUploadApi(data),
        })
      );
    } else if (
      successCount < responseItemsCount &&
      failedCount < responseItemsCount &&
      alreadyUploadedCount < responseItemsCount &&
      responseItemsCount === successCount + failedCount + alreadyUploadedCount
    ) {
      if (successCount > 0) {
        notificationMsg += `${successCount} ${TEXT.EMAILS_UPLOADED_TO_ICI_SUCCESSFULLY}.\n`;
      }
      if (alreadyUploadedCount > 0) {
        notificationMsg += `${alreadyUploadedCount} ${TEXT.EMAILS_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY}.\n`;
      }
      if (failedCount > 0) {
        notificationMsg += `${failedCount} ${TEXT.EMAILS_FAILED_TO_BE_UPLOADED_TO_ICI}.\n`;
      }
      notificationMsg = notificationMsg.replace(/(^\n)|(\n$)/g, "") + `\n`;
      if (failedCount > 0) {
        failedItems.forEach((item) => {
          if (isActionValidatorPresent(item) && actionValidatorMessage(item, errorValidationMsg)) {
            notificationMsg += `\n${actionValidatorMessage(item, errorValidationMsg)}\n`;
          } else {
            notificationMsg += `\n${item.ResponseMsg}\n`;
          }
        });
      }
      dispatch(showNotificationWarning(notificationMsg));
    } else if (responseItemsCount === 1 && failedCount === 1) {
      if (isActionValidatorPresent(responseItems[0]) && actionValidatorMessage(responseItems[0], errorValidationMsg)) {
        notificationMsg = actionValidatorMessage(responseItems[0], errorValidationMsg);
      } else {
        notificationMsg = responseItems[0].ResponseMsg;
      }
      dispatch(
        showNotificationError({
          message: notificationMsg,
          retryFunction: () => callToUploadApi(data),
        })
      );
    }
  } else {
    notificationMsg = errorValidationMsg.UPLOAD_FAILED_GENERIC_MESSAGE;
    dispatch(
      showNotificationError({
        message: notificationMsg,
        retryFunction: () => callToUploadApi(data),
      })
    );
    logError({
      dispatch: dispatch,
      err: `${notificationMsg} ${TEXT.RESPONSE_ITEMS_EMPTY}`,
      callerInfo: {
        callerFunction: "ClientApp|src|taskpane|containers|add-to-ici|utils - callToUploadApi",
        callerApi: "Agreement/UploadDocumentsForAddIn",
      },
    });
  }
  stopUploadingDnD({ from: from, dispatch: dispatch, onUpload: onUpload, alreadyUploadedItems: alreadyUploadedItems });
};

const stopUploadingDnD = ({ from, dispatch, onUpload, alreadyUploadedItems }) => {
  if (from === UPLOAD_REQUEST_FROM.AGREEMENT) {
    dispatch(stopUploadingDndAgreement());
  }
  if (from === UPLOAD_REQUEST_FROM.ASSOCIATION) {
    dispatch(stopUploadingDndAssociation());
  }
  if (from === UPLOAD_REQUEST_FROM.FOLDER) {
    dispatch(stopUploadingDndFolder());
    setTimeout(() => {
      onUpload();
    }, 3000);
  }
  if (from === UPLOAD_REQUEST_FROM.ASSOCIATION_INSTANCE) {
    dispatch(stopUploadingDndAssociationInstance());
  }
  if (from === UPLOAD_REQUEST_FROM.FOLDER_INSTANCE) {
    dispatch(stopUploadingDndFolderInstance());
  }
  if (alreadyUploadedItems && alreadyUploadedItems.length > 0) {
    dispatch(showReplaceExistingPopup());
    dispatch(storeReplaceExistingData(alreadyUploadedItems));
  }
};

const uploadResponseHandlerSingleEmailUpload = ({ data, dispatch, retryFunction, errorValidationMsg }) => {
  const responseItems = data && data.responseItems && data.responseItems.length > 0 ? data.responseItems : [];
  let responseItemsCount = 0,
    successCount = 0,
    failedItems = [],
    failedCount = 0,
    alreadyUploadedCount = 0,
    notificationMsg = "";
  if (responseItems && responseItems.length > 0) {
    responseItemsCount = responseItems.length;
    successCount = responseItems.filter((responseItem) => responseItem.Status === TEXT.SUCCESS).length;
    failedItems = responseItems.filter(
      (responseItem) => responseItem.Status === TEXT.FAILURE || responseItem.Status === TEXT.FAILED
    );
    failedCount = failedItems.length;
    alreadyUploadedCount = responseItems.filter((responseItem) => responseItem.Status === "Already Uploaded").length;

    if (responseItemsCount === successCount) {
      notificationMsg = `${successCount} ${TEXT.ATTACHMENTS_UPLOADED_TO_ICI_SUCCESSFULLY}`;
      dispatch(hideSingleEmailUpload());
      dispatch(showNotificationSuccess(notificationMsg));
      setTimeout(() => {
        dispatch(hideNotification());
        dispatch(showIsUploadDoneSingleEmail());
      }, 2000);
    } else if (responseItemsCount === alreadyUploadedCount) {
      notificationMsg = `${TEXT.EMAIL_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY}`;
      dispatch(hideSingleEmailUpload());
      dispatch(showNotificationWarning(notificationMsg));
      setTimeout(() => {
        dispatch(hideNotification());
        dispatch(showIsUploadDoneSingleEmail());
      }, 2000);
    } else if (responseItemsCount > 1 && failedCount > 1 && responseItemsCount === failedCount) {
      notificationMsg = `${failedCount} ${TEXT.ATTACHMENTS_FAILED_TO_BE_UPLOADED_TO_ICI}\n`;
      notificationMsg = notificationMsg.replace(/(^\n)|(\n$)/g, "") + `\n`;
      failedItems.forEach((item) => {
        if (isActionValidatorPresent(item) && actionValidatorMessage(item, errorValidationMsg)) {
          notificationMsg += `\n${actionValidatorMessage(item, errorValidationMsg)}\n`;
        } else {
          notificationMsg += `\n${item.ResponseMsg}\n`;
        }
      });
      dispatch(hideSingleEmailUpload());
      dispatch(
        showNotificationError({
          message: notificationMsg,
          retryFunction: retryFunction,
        })
      );
    } else if (
      successCount < responseItemsCount &&
      failedCount < responseItemsCount &&
      alreadyUploadedCount < responseItemsCount &&
      responseItemsCount === successCount + failedCount + alreadyUploadedCount
    ) {
      if (successCount > 0) {
        notificationMsg += `${successCount} ${TEXT.ATTACHMENTS_UPLOADED_TO_ICI_SUCCESSFULLY}.\n`;
      }
      if (alreadyUploadedCount > 0) {
        notificationMsg += `${TEXT.EMAIL_ALREADY_UPLOADED_TO_ICI_SUCCESSFULLY}.\n`;
      }
      if (failedCount > 0) {
        notificationMsg += `${failedCount} ${TEXT.ATTACHMENTS_FAILED_TO_BE_UPLOADED_TO_ICI}.\n`;
      }
      notificationMsg = notificationMsg.replace(/(^\n)|(\n$)/g, "") + `\n`;
      if (failedCount > 0) {
        failedItems.forEach((item) => {
          if (item.ResponseMsg === TEXT.ACTUAL_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE) {
            notificationMsg += `\n${TEXT.EXPECTED_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE}\n`;
          } else {
            if (isActionValidatorPresent(item) && actionValidatorMessage(item, errorValidationMsg)) {
              notificationMsg += `\n${actionValidatorMessage(item, errorValidationMsg)}\n`;
            } else {
              notificationMsg += `\n${item.ResponseMsg}\n`;
            }
          }
        });
      }
      dispatch(hideSingleEmailUpload());
      dispatch(showNotificationWarning(notificationMsg));
    } else if (responseItemsCount === 1 && failedCount === 1) {
      if (isActionValidatorPresent(responseItems[0]) && actionValidatorMessage(responseItems[0], errorValidationMsg)) {
        notificationMsg = actionValidatorMessage(responseItems[0], errorValidationMsg);
      } else {
        notificationMsg = responseItems[0].ResponseMsg;
      }
      if (notificationMsg === TEXT.ACTUAL_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE) {
        notificationMsg = TEXT.EXPECTED_AGREEMENT_NEW_VERSION_EXCEPTION_MESSAGE;
        dispatch(hideSingleEmailUpload());
        dispatch(showNotificationWarning(notificationMsg));
      } else {
        dispatch(hideSingleEmailUpload());
        dispatch(
          showNotificationError({
            message: notificationMsg,
            retryFunction: retryFunction,
          })
        );
      }
    }
  } else {
    notificationMsg = errorValidationMsg.UPLOAD_FAILED_GENERIC_MESSAGE;
    dispatch(hideSingleEmailUpload());
    dispatch(
      showNotificationError({
        message: notificationMsg,
        retryFunction: retryFunction,
      })
    );
  }
};

const stopUploadingSingleEmailUpload = ({ dispatch }) => {
  dispatch(hideSingleEmailUpload());
};

const uploadResponseHandlerSingleEmailThreadReplacePopup = ({ dispatch, data, onUpload }) => {
  const responseData = data && data.responseItems && data.responseItems.length > 0 ? data.responseItems : [];
  if (responseData && responseData.length > 0) {
    if (responseData[0].Status === TEXT.SUCCESS) {
      dispatch(showNotificationSuccess(`1 ${TEXT.EMAILS_UPLOADED_TO_ICI_SUCCESSFULLY}`));
    }
    if (responseData[0].Status === TEXT.FAILED || responseData[0].Status === TEXT.FAILURE) {
      dispatch(showNotificationWarning(`1 ${TEXT.EMAILS_FAILED_TO_BE_UPLOADED_TO_ICI}`));
    }
  } else {
    dispatch(showNotificationWarning(`1 ${TEXT.EMAILS_FAILED_TO_BE_UPLOADED_TO_ICI}`));
  }
  onUpload();
};

const stopUploadingSingleEmailThreadReplacePopup = ({ onUpload }) => {
  onUpload();
};

const uploadResponseHandlerDnDSingleEmailThreadUpload = ({ response, dispatch }) => {
  const responseItems =
    response && response.responseItems && response.responseItems.length > 0 ? response.responseItems[0] : null;
  dispatch(storeUploadSingleEmailThreadData(responseItems));
  stopUploadingDnDSingleEmailThreadUpload({ dispatch: dispatch });
};

const stopUploadingDnDSingleEmailThreadUpload = ({ dispatch }) => {
  dispatch(stopUploadingSingleEmailThread());
};

const isActionValidatorPresent = (data) => {
  return (
    data.ActionValidatorsList &&
    data.ActionValidatorsList.length > 0 &&
    data.ActionValidatorsList[0].ActionValidatorType == TEXT.ACTION_VALIDATOR_ERROR_CODE &&
    data.ActionValidatorsList[0].ValidationStatus === TEXT.MISSING_CONFIGURATION_VALUE &&
    data.ActionValidatorsList[0].ValidationMessage
  );
};

const actionValidatorMessage = (data, errorValidationMsg) => {
  const message = data.ActionValidatorsList[0].ValidationMessage;
  if (message === TEXT.UPLOAD_FAILED_TEAM_SCENARIO) {
    return errorValidationMsg.UPLOAD_FAILED_TEAM_SCENARIO;
  } else if (message === TEXT.UPLOAD_FAILED_ALLOW_MULTIPLE_INSTANCE_SCENARIO) {
    return errorValidationMsg.UPLOAD_FAILED_ALLOW_MULTIPLE_INSTANCE_SCENARIO;
  } else {
    return "";
  }
};

export const getValidatedEmail = (emailData) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(emailData);
};

export const extractHostname = (url) => {
  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
};

const isSafeHostname = (hostname, allowedDomains) => {
  return allowedDomains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
};

export const isValidAuthUrl = (urlData) => {
  try {
    const parsed = new URL(urlData);
    const allowedDomains = ["login.microsoftonline.com", "login.microsoftonline.us"];
    return parsed.protocol === "https:" && isSafeHostname(parsed.hostname, allowedDomains);
  } catch {
    return false;
  }
};

export const isValidRedirectUrl = (urlData) => {
  try {
    const parsed = new URL(urlData);
    const allowedDomains = [
      extractHostname(configService.getPluginDomain()),
      extractHostname(configService.getIcmUrl()),
      extractHostname(configService.getApiUrl()),
      extractHostname(configService.getRedirectUri()),
    ];
    return (
      parsed.protocol === "https:" &&
      parsed.pathname.includes("taskpane.html") &&
      isSafeHostname(parsed.hostname, allowedDomains)
    );
  } catch {
    return false;
  }
};
